import { Namespace } from "@smart/itops-types-basic";

import { CloudfrontDef } from "./cloudfront";
import { LambdaDef } from "./lambda";

export type WebSocketLambdaDef<D extends string, E extends string> = LambdaDef<
  D,
  E
> & {
  routes: string[];
};

export type WebSocketGatewayDef<
  G extends string,
  C extends string,
  E extends string,
  L extends string,
  LD extends Readonly<{
    [k in L]: WebSocketLambdaDef<k, E>;
  }>,
> = {
  namespace: Namespace<string, G>;
  cdn: CloudfrontDef<C, string>;
  prefix: string;
  envKeys: readonly E[];
  lambdaKeys: L[];
  lambdas: LD;
  port: number;
};

export const buildWebSocketGatewayDef = <
  G extends string,
  C extends string,
  E extends string,
  L extends string,
  LD extends Readonly<{
    [k in L]: WebSocketLambdaDef<k, E>;
  }>,
>(
  def: WebSocketGatewayDef<G, C, E, L, LD>,
) => def;
